import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { Button, Card, CardBody, CardHeader, Spinner } from "reactstrap";
import { DataTable } from "../../components/FieldCustomizer/FieldCustomizer";
import "../../components/FieldCustomizer/FieldCustomizer.css";

const DEFAULT_COLS = [
  { id:"station",     label:"Station",     field:"station",     visible:true },
  { id:"description", label:"Description", field:"description", visible:true },
  { id:"date",        label:"Date",        field:"date",        visible:true },
  { id:"time",        label:"Time",        field:"time",        visible:true },
];

const AlarmList = ({ selectedDate, selectedShift, selectedMachine, columnConfig }) => {
  const [alarms,  setAlarms]  = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = columnConfig || DEFAULT_COLS;

  const transformAlarmData = (apiResponse) => {
    return (apiResponse?.results || []).flatMap(item =>
      (item.alarms || []).map(alarm => ({
        date:        item.date,
        time:        item.time,
        station:     item.station,
        description: alarm.description,
      }))
    );
  };

  const exportToExcel = () => {
    if (!alarms.length) return;
    const ws = XLSX.utils.json_to_sheet(alarms);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Alarms");
    XLSX.writeFile(wb, `Alarms_${selectedMachine}_${selectedDate}_Shift${selectedShift}.xlsx`);
  };

  useEffect(() => {
    const fetchAlarms = async () => {
      try {
        const res = await axios.get(
          `https://api.hanoch.in/api/mcc/latest-resolve-alarm/?machine_id=${selectedMachine}&date=${selectedDate}&shift=${selectedShift}`
        );
        setAlarms(transformAlarmData(res));
      } catch(e) { console.error("Alarm fetch error:", e); }
      finally    { setLoading(false); }
    };
    fetchAlarms();
    const id = setInterval(fetchAlarms, 60000);
    return () => clearInterval(id);
  }, [selectedMachine, selectedDate, selectedShift]);

  return (
    <Card className="h-100 mb-0">
      <CardHeader className="d-flex justify-content-between align-items-center py-2">
        <strong style={{fontSize:13}}>Latest Alarms</strong>
        <Button size="sm" color="success" onClick={exportToExcel} disabled={!alarms.length}>
          <i className="mdi mdi-microsoft-excel me-1"/>Export
        </Button>
      </CardHeader>
      <CardBody style={{padding:0,height:"calc(100% - 48px)",overflow:"auto"}}>
        {loading
          ? <div className="d-flex justify-content-center align-items-center h-100"><Spinner color="primary"/></div>
          : <DataTable columns={columns} rows={alarms} />
        }
      </CardBody>
    </Card>
  );
};

export default AlarmList;
